import React from 'react';
import { AvTooltip, AvTooltipProps } from '@fabric-ui/components';
import { FailFull as Error } from '@fabric-ui/icons/colorful';
import { flex } from '@fabric-ui/theme';
import { isNullOrUndefined } from '@fabric-ui/utils';
import { Box, Fade, SxProps, Tooltip } from '@mui/material';

const errorIcon = <Error />;

export function ErrorTooltip({
  error,
  children,
  open,
  sx,
}: {
  error: string;
  children: React.JSX.Element;
  open?: boolean;
  sx?: SxProps | AvTooltipProps['sx'];
}) {
  return (
    <AvTooltip
      variant="message"
      color="white"
      muiProps={isNullOrUndefined(open) ? {} : { open }}
      hasWidthLimit={false}
      title={
        <Box sx={{ ...flex.itemsCenter, gap: 1 }}>
          {errorIcon}
          {error}
        </Box>
      }
      sx={sx}>
      {children}
    </AvTooltip>
  );
}

const messageTooltipStyles = {
  tooltip: {
    sx: {
      fontSize: 14,
      padding: 1.5,
      background: 'var(--color-surface-elevated-10)',
      color: 'var(--color-content-base-primary)',
      maxWidth: 'none',
    },
  },
  arrow: { sx: { color: 'var(--color-surface-elevated-10)' } },
};

export function InputTooltipWrapper({
  tooltipContent,
  error,
  inputNode,
  value,
  children,
  sx,
}: {
  tooltipContent?: string | React.ReactNode;
  error?: any;
  inputNode?: HTMLInputElement | null;
  value?: string | number | readonly string[];
  children: any;
  sx?: AvTooltipProps['sx'] | SxProps;
}) {
  const isMessage = !!(tooltipContent || error);
  const title = tooltipContent ? (
    tooltipContent
  ) : error ? (
    <Box sx={{ ...flex.itemsCenter, gap: 1 }}>
      {errorIcon}
      {error}
    </Box>
  ) : inputNode && inputNode.scrollWidth > inputNode.clientWidth ? (
    value
  ) : (
    ''
  );

  return (
    <Tooltip
      title={title}
      arrow={isMessage}
      placement={isMessage ? 'top' : 'bottom'}
      slotProps={isMessage ? messageTooltipStyles : undefined}
      TransitionComponent={isMessage ? Fade : undefined}
      disableInteractive
      TransitionProps={isMessage ? { timeout: 200 } : undefined}
      sx={sx}>
      {children}
    </Tooltip>
  );
}
